import { ReactElement, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
import firebase from "firebase/app";
import "firebase/firestore";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Layout, Menu, Image, Descriptions, Button,Breadcrumb, Modal, message } from "antd";
import { ShopOutlined, HomeOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { getAuthState } from "../../redux/selectors";
import { BUY_PRODUCT_REQUEST } from "../../redux/constants";
import "../../assets/css/index.css";
import api from "../../redux/api/axiosInstance";
import { ShopHeaderBar } from "../../components/index";
import Loading from "../../components/Loading";

export function Orders(): ReactElement {
    
const dispatch = useDispatch();
const history = useHistory();
const { t } = useTranslation();
const { Content } = Layout;
const [products, setProducts] = useState<any>();
const { orderID } = useParams<{ orderID: string }>();
const { currentUser } = useSelector(getAuthState);
const [loading, setLoading] = useState<boolean>(false);
const [orderData, setOrderData] = useState<any>();
const [productData, setProductData] = useState<any>();
const [buyerData, setBuyerData] = useState<any>();


const getProductsInfo = async () => {
    setLoading(true);

    const requestSnapshot = await firebase.firestore().collection("request_item").doc(orderID).get();
    const requestData = requestSnapshot.data();

    const buyerSnapshot = await firebase.firestore().collection("users").doc(requestData?.buyer).get();
    const buyer = buyerSnapshot.data();

    const productSnapshot = await firebase.firestore().collection("products").doc(requestData?.product_id).get();
    const product = productSnapshot.data();

    setOrderData(requestData);    
    setBuyerData(buyer);   
    setProductData(product);    
    setLoading(false);
}


const getCondition = (condition : any) => {
    switch(condition) {
        case 1 :
            return "Excellent"
        case 2 :
            return "Good"
        case 3 :
            return "Heavily used"
        case 4 :
            return "New"
        default : 
            return "Excellent"
    } 
}

useEffect(() => {
    getProductsInfo();
}, []);

return (
    <Layout>
        {loading && <Loading /> }
        {!currentUser && <ShopHeaderBar /> }
        <Content style={{ margin: '30px 16px 50px'}}>
            <Row justify="center" gutter={[20,10]}>
                <Col span={24}>
                    <Breadcrumb>
                        <Breadcrumb.Item href="">
                            <HomeOutlined />
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href="">
                            <span>Order Detail</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
            </Row>
            <Row  style={{ margin: '30px 16px 50px'}} justify="center" gutter={[20,10]}>
                <Col xs={24} sm={24} md={12} lg={8} xl={10}>
                    <Image
                        src={productData?.photo}
                        width="100%"
                    />
                </Col>
                <Col xs={24} sm={24} md={12} lg={16} xl={12}>
                    <Card title={products?.name} bordered={false} headStyle={{color:"#036198",fontSize:30}} style={{ width: "100%" }}>
                        <Descriptions title="" bordered style={{marginBottom:20}}>
                            <Descriptions.Item span={3} label={t("table.product_name")}>{productData?.name}</Descriptions.Item>
                            <Descriptions.Item span={3} label={t("table.price")}>{productData?.currency} {productData?.cost}</Descriptions.Item>
                            <Descriptions.Item span={3} label={t("table.condition")}>{getCondition(productData?.condition)}</Descriptions.Item>
                            <Descriptions.Item span={3} label={t("table.quantity")}>{orderData?.qty}</Descriptions.Item>
                            <Descriptions.Item span={3} label={t("table.request_date")}>{ moment(orderData?.makedate.seconds * 1000).format("MMM DD, YYYY H:mm A")}</Descriptions.Item>
                            <Descriptions.Item span={3} label={t("market.vendor_contact")}>
                                <p>{t("table.name")}: {buyerData?.fullName}</p>
                                <a href={`mailto:${buyerData?.email}`}>{t("table.email")}: {buyerData?.email}</a><br />
                                { buyerData?.phoneNumber && <a href={`tel:${buyerData?.phoneNumber}`}>{t("table.number")}: {buyerData?.phoneNumber}</a>}
                            </Descriptions.Item>
                        </Descriptions>
                        {products?.shipping === 1 && 
                            <h1 style={{fontSize:20,color:"#036198",marginTop:30}}><ShopOutlined style={{fontSize:22,marginTop:10}} twoToneColor="#eb2f96" /> {t("market.product_shipping")}</h1>
                        }
                    </Card>
                </Col>
            </Row>
        </Content>
  </Layout>
  );
}
